import { render, staticRenderFns } from "./ModalSwitchAccount.vue?vue&type=template&id=ed337a04&scoped=true&"
import script from "./ModalSwitchAccount.vue?vue&type=script&lang=ts&"
export * from "./ModalSwitchAccount.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSwitchAccount.vue?vue&type=style&index=0&id=ed337a04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed337a04",
  null
  
)

export default component.exports